import { ClientWithAuth, setCustomRequestId } from 'client/services/service';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';

const serviceUrlSuffix = '/enquiry-request-service';

export default {
    postEnquiry: async (enquiry, requestId) => {
        const epsgCode = await getEpsgCode();
        const timeout = 90000;
        const headers = requestId
            ? setCustomRequestId(ClientWithAuth.defaults.headers, requestId)
            : ClientWithAuth.defaults.headers;

        const config = {
            headers,
            timeout
        };

        const response = await ClientWithAuth.post(
            `${serviceUrlSuffix}/${epsgCode}/enquiries`,
            JSON.stringify(enquiry),
            config
        );

        return {
            ...response.data
        };
    },

    getEnquiryRequest: async (enquiryId) => {
        const response = await ClientWithAuth.get(
            `${serviceUrlSuffix}/enquiries/${enquiryId}`
        );

        return {
            ...response.data
        };
    },
    getEnquiriesRequest: async (params) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/enquiries`, { params });
        return {
            ...response.data
        };
    },

    getNotificationStatuses: async (enquiryId) => {
        const response = await ClientWithAuth.get(
            `${serviceUrlSuffix}/enquiries/${enquiryId}/notification-statuses`
        );

        return response.data;
    },

    getAffectedAssetOwners: async (enquiryId) => {
        const response = await ClientWithAuth.get(
            `${serviceUrlSuffix}/enquiries/${enquiryId}/affected-asset-owners`
        );

        return response.data;
    },

    deleteEnquiries: async (enquiryIds) => {
        const response = await ClientWithAuth.delete(`${serviceUrlSuffix}/enquiries`, { data: enquiryIds });
        return {
            ...response?.data
        };
    },
    getActivityTypes: async (locale) => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/activityTypes`);
        return response.data.activityTypes;
    }
};
